import axios from 'axios';

// Token storage and management
let token = null;
let tokenExpiration = null;

/**
 * Check if the token needs renewal and get a new one if needed
 * @returns {Promise<string>} - The valid token
 */
export const getValidToken = async () => {
    // Check if token is expired or will expire in the next minute
    if (!token || !tokenExpiration || Date.now() >= tokenExpiration - 60000) {
        try {
            const apiKey = process.env.VUE_APP_API_KEY;
            const response = await axios.post('/api/token', {}, {
                headers: {
                    'x-api-key': apiKey
                }
            });
            token = response.data.token;
            // Set expiration to 15 minutes from now
            tokenExpiration = Date.now() + (15 * 60 * 1000);
        } catch (error) {
            console.error('Error fetching token:', error);
            throw error;
        }
    }
    return token;
};

/**
 * Clear the token (use on auth failures)
 */
export const clearToken = () => {
    token = null;
    tokenExpiration = null;
};

/**
 * Get authenticated API headers for requests
 * @returns {Promise<Object>} Headers with authentication token
 */
export const getAuthHeaders = async () => {
    const token = await getValidToken();
    return {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json'
    };
};

/**
 * Makes an authenticated GET request
 * @param {string} url - API endpoint
 * @returns {Promise<Object>} - API response
 */
export const authenticatedGet = async (url) => {
    try {
        const headers = await getAuthHeaders();
        return await axios.get(url, { headers });
    } catch (error) {
        if (error.response?.status === 401 || error.response?.status === 403) {
            // Token expired or invalid, clear it and try again once
            clearToken();
            const headers = await getAuthHeaders();
            return await axios.get(url, { headers });
        }
        throw error;
    }
}; 